/**
 * Dynamic hero tagline by time of day in the given IANA timezone
 * (office / user locality — e.g. Australia/Sydney or Asia/Kolkata).
 */
export function getDashboardHeroTagline(timeZone = 'Asia/Kolkata') {
  const now = new Date();

  let hour = now.getHours();
  try {
    const hourPart = new Intl.DateTimeFormat('en-US', {
      timeZone,
      hour: 'numeric',
      hour12: false
    })
      .formatToParts(now)
      .find((p) => p.type === 'hour')?.value;
    hour = Number(hourPart);
    if (!Number.isFinite(hour)) hour = now.getHours();
    // en-US hour12:false can return "24" for midnight in some engines
    if (hour === 24) hour = 0;
  } catch {
    /* keep browser hour */
  }

  let timeStr;
  try {
    timeStr = now.toLocaleTimeString('en-US', {
      timeZone,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } catch {
    timeStr = now.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  if (hour < 5) {
    return `It's ${timeStr} — here's a calm snapshot of your team whenever you're ready.`;
  }
  if (hour < 12) {
    return `Good morning! It's ${timeStr}. Here's what your team is up to today.`;
  }
  if (hour < 14) {
    return `Midday check-in at ${timeStr} — stay on top of leaves, milestones, and hiring.`;
  }
  if (hour < 17) {
    return `Good afternoon (${timeStr}). Here's your live team overview.`;
  }
  if (hour < 21) {
    return `Good evening. It's ${timeStr} — quick pulse on your team before you wrap up.`;
  }
  return `It's ${timeStr} — your dashboard is here whenever you need it.`;
}
